import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import t from '../../lib/I18n';

function AccountHeader(props) {
    const classes = classnames(
        'text-primary padding-top--sm padding-bottom--sm border--bottom text-lg no-margin',
        {
            'hidden-mobile hidden-tablet-portrait': !props.isStaticPage,
            'text-center': props.isStaticPage && !props.disableCentered,
            'header--smartcard': props.smartcardHeader,
        },
    );

    const headerContainerClasses = classnames('account-header__container border--bottom', {
        'header--with-button': props.isReservation,
    });

    if (props.button !== undefined) {
        return (
            <div className={headerContainerClasses}>
                <h1 className={classes}>{props.children}</h1>
                {props.button}
                {props.isReservation && (
                    <button
                        onClick={() => props.openJourneyModal(true)}
                        className="btn action-btn action-btn--primary make-a-reservation-button"
                    >
                        {t('account.reservation.button')}
                    </button>
                )}
            </div>
        );
    }
    return <h1 className={classes}>{props.children}</h1>;
}

AccountHeader.propTypes = {
    children: PropTypes.any,
    isStaticPage: PropTypes.bool,
    smartcardHeader: PropTypes.bool,
    disableCentered: PropTypes.bool,
    button: PropTypes.node,
    isReservation: PropTypes.bool,
    openJourneyModal: PropTypes.func,
};

AccountHeader.defaultProps = {
    isStaticPage: false,
    smartcardHeader: false,
    disableCentered: false,
    isPassengerAssist: false,
    button: null,
};

export default AccountHeader;
